import { render } from "./StcCheck.vue?vue&type=template&id=4ddf83b3&scoped=true"
import script from "./StcCheck.vue?vue&type=script&lang=js"
export * from "./StcCheck.vue?vue&type=script&lang=js"

import "./StcCheck.vue?vue&type=style&index=0&id=4ddf83b3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ddf83b3"]])

export default __exports__